module.exports = __webpack_public_path__ + "static/finance_planning_group_logo-245aa533a76b412b7a8f5292bf0a7390.svg";